import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export enum EInvoicesReceivingType {
    LastReceivingDate = 'LastReceivingDate',
    DateRange = 'DateRange',
    ByKsefNumber = 'ByKsefNumber'
}

export type EInvoiceReceivedDownloadHeadersParams = {
    readonly fromDateTime: Date;
    readonly type: EInvoicesReceivingType.LastReceivingDate
} | {
    readonly type: EInvoicesReceivingType.DateRange,
    readonly fromDateTime: Date,
    readonly toDateTime: Date
} | {
    readonly type: EInvoicesReceivingType.ByKsefNumber,
    readonly ksefNumber: string
};

export type EInvoiceReceivedDownloadHeadersResponse = {
    id: number,
    version: string
};

export class EInvoiceReceivedDownloadHeadersCommand extends Command<EInvoiceReceivedDownloadHeadersParams, EInvoiceReceivedDownloadHeadersResponse> { }

@CommandHandlerFor(EInvoiceReceivedDownloadHeadersCommand)
@Injectable({ providedIn: 'root'})
export class EInvoiceReceivedDownloadHeadersCommandHandler {
    #Url = TaggedUrl.join('eInvoices/headers/tasks', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(cmd: EInvoiceReceivedDownloadHeadersCommand): Promise<EInvoiceReceivedDownloadHeadersResponse> {
        const { data } = await this.#http.post(
            this.#Url,
            cmd.params,
            {
                transformRequest: [
                    d => JSON.stringify(d)
                ]
            }
        );
        return data;
    }
}
